export default __webpack_public_path__ + "static/media/usb-cable.445fb9fb.png";